'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stars = undefined;

var _Stars2 = require('./Stars');

var _Stars3 = _interopRequireDefault(_Stars2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Stars = _Stars3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Stars/index.js
// module id = 1640
// module chunks = 0